module.exports = __webpack_public_path__ + "img/banner1.df21f1f4.png";